'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002491 from "./presto.types$$anon$91.js";
import * as $j_presto$002etypes$0024$002dAllow$002dPayload$0024 from "./presto.types$-Allow-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$90(outer) {
  this.caT = null;
  this.caL = null;
  this.caM = false;
  this.caU = null;
  this.caV = false;
  this.caY = null;
  this.caR = null;
  this.caS = false;
  this.caN = null;
  this.caO = false;
  this.caP = null;
  this.caQ = false;
  this.caW = false;
  this.caX = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.caT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.caY = "AllowPayload";
}
export { $c_Lpresto_types$Rule$$anon$90 as $c_Lpresto_types$Rule$$anon$90 };
$p = $c_Lpresto_types$Rule$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$90;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$90() {
}
export { $h_Lpresto_types$Rule$$anon$90 as $h_Lpresto_types$Rule$$anon$90 };
$h_Lpresto_types$Rule$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.caT;
});
$p.M = (function() {
  if ((!this.caM)) {
    this.caL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.caM = true;
  }
  return this.caL;
});
$p.O = (function() {
  if ((!this.caV)) {
    this.caU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.caV = true;
  }
  return this.caU;
});
$p.D = (function() {
  return this.caY;
});
$p.t = (function() {
  if ((!this.caS)) {
    this.caR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.caS = true;
  }
  return this.caR;
});
$p.N = (function() {
  if ((!this.caO)) {
    this.caN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().Tk(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.caO = true;
  }
  return this.caN;
});
$p.Q = (function() {
  if ((!this.caQ)) {
    this.caP = new $j_presto$002etypes$0024$0024anon$002491.$c_Lpresto_types$$anon$91();
    this.caQ = true;
  }
  return this.caP;
});
$p.v = (function() {
  if ((!this.caX)) {
    this.caW = false;
    this.caX = true;
  }
  return this.caW;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee90) => ((p) => \u03b4scrutinee90.cHh(p)))($j_presto$002etypes$0024$002dAllow$002dPayload$0024.$m_Lpresto_types$AllowPayload$())));
});
var $d_Lpresto_types$Rule$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$90, "presto.types$Rule$$anon$90", ({
  a1l: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$90 as $d_Lpresto_types$Rule$$anon$90 };
//# sourceMappingURL=presto.types$-Rule$$anon$90.js.map
